<template>
  <div v-on:click="openMapLink()" class="block_container">
    <span class="tag">{{type}}</span>
    <h2 class="name">{{name}}</h2>
    <div class="">
      <img class="location" alt="location" src="../assets/location.png">
      <span class="loc_text" >{{location}}</span>
    </div>
    <div>
      <img class="call" alt="call" src="../assets/call.png">
      <span class="num_text" >{{number}}</span>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    name: String,
    type: String,
    location: String,
    number: String,
    mapLink: String
  },
  methods: {
    openMapLink() {
      const win = window.open(this.mapLink, '_blank');
      win.focus();
    }
  }
}
</script>

<style scoped>
.flex{display: flex}
.flex-col{flex-direction: column}
.justify-center {justify-content: center}

a { color: white }

.block_container {
  width: 300px;
  height: 180px;
  margin-bottom: 20px;
  padding-left: 20px;

  border-radius: 20px;
  border: 1px solid #e5e5e5;
  background-color: #fcfcfc;

  filter: drop-shadow(3px 7px 9px #dedede);
}

.tag {
  height: 20px;
  width: auto;

  font-size: 13px;
  border-radius: 10px;

  padding: 3px 5px 3px 5px;
  color: white;
  background-color: #076ba7;
}

.name {
  margin-top: 10px;
  font-size: 28px;
}

.location {
  width: 20px;
  padding-top: 5px;
  margin-right: 3px;
}
.call {
  width: 20px;
  padding-top: 5px;
  margin-right: 5px;
}

.loc_text, .num_text {
  padding-bottom: 5px;
}
</style>
